type SignupStepHeaderProps = {
  title: string;
  subtitle: string;
  step: number;
  totalSteps?: number;
};

export function SignupStepHeader({
  title,
  subtitle,
  step,
  totalSteps = 4,
}: SignupStepHeaderProps) {
  return (
    <header className="mb-5 sm:mb-6">
      <p
        className="mb-2 text-[11px] font-semibold tracking-[0.08em] text-[#736F8E] uppercase"
        style={{ fontFamily: "'JetBrains Mono', monospace" }}
      >
        Step {step} of {totalSteps}
      </p>
      <div className="mb-4 flex gap-1.5">
        {Array.from({ length: totalSteps }, (_, i) => (
          <span
            key={i}
            className={`h-1.5 flex-1 rounded-full transition-colors ${
              i < step ? 'bg-gradient-to-r from-[#3B62BD] to-[#7653A8]' : 'bg-[#EAE8F5]'
            }`}
          />
        ))}
      </div>
      <h2
        className="m-0 text-[30px] font-extrabold leading-tight tracking-tight text-[#2E2A54]"
        style={{ fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif" }}
      >
        {title}
      </h2>
      <p className="mt-1.5 mb-0 text-[14px] leading-snug text-[#736F8E]">
        {subtitle}
      </p>
    </header>
  );
}
